import React from "react";
import { TrDetalleEmbudoVentas } from "./TrDetalleEmbudoVentas";
import AgricultureIcon from '@mui/icons-material/Agriculture';
import CellTowerIcon from '@mui/icons-material/CellTower';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import StarsIcon from '@mui/icons-material/Stars';
import BathroomIcon from '@mui/icons-material/Bathroom';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const TablaEmbudo = ({ data, lineas, verpor }) => {
  const columnas = [
    ...new Set(
      data.map((x) => x.columna).filter((c) => c && c.trim() !== "")
    ),
  ];

  const fases = [
    ...new Set(data.map((x) => x.fase).filter((f) => f && f.trim() !== "")),
  ];

  const obtenerTotalFila = (fase, lineaNombre) => {
    return data
      .filter(x => x.fase === fase && x.linea === lineaNombre)
      .reduce((sum, x) => sum + (x.cantidad || 0), 0);
  };

  const obtenerTotalesPorLinea = (lineaNombre) => {
    return columnas.map((col) => {
      const items = data.filter((x) => x.linea === lineaNombre && x.columna === col);

      return {
        col,
        totalCantidad: items.reduce((acc, cur) => acc + (cur.cantidad || 0), 0),
        totalMonto: items.reduce((acc, cur) => acc + (cur.monto || 0), 0)
      };
    });
  };

  // 🔹 Filtrar datos válidos
  const dataFiltrada = data.filter((x) => columnas.includes(x.columna));

  // 🔹 Consolidado dinámico
  const consolidado = fases.map((fase) => {
    const row = { fase };
    columnas.forEach((col) => {
      const items = dataFiltrada.filter((x) => x.fase === fase && x.columna === col);

      row[col] = {
        cantidad: items.reduce((sum, curr) => sum + (curr.cantidad || 0), 0),
        monto: items.reduce((sum, curr) => sum + (curr.monto || 0), 0)
      };
    });
    return row;
  });

  const mostrarValor = (cantidad, monto) => {
    if (verpor === "unidades") return cantidad || 0;
    if (verpor === "montos") return FormatMoney(monto, 0) || 0;

    if (verpor === "unidadesmonto") {
      return `${cantidad || 0} - $${FormatMoney(monto, 0) || 0}`;
    }

    return cantidad || 0;
  };

  const iconosMap = {
    AgricultureIcon: <AgricultureIcon />,
    CellTowerIcon: <CellTowerIcon />,
    GroupWorkIcon: <GroupWorkIcon />,
    StarsIcon: <StarsIcon />,
    BathroomIcon: <BathroomIcon />,
    HomeRepairServiceIcon: <HomeRepairServiceIcon />
  };

  return (
    <div className="pebcd-tabla scroll">
      <table cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>FASE</th>
            {columnas.map((col) => (
              <th><div>{col.toUpperCase()}</div></th>
            ))}
            <th><div>TOTAL</div></th>
          </tr>
        </thead>
        <tbody>
          {dataFiltrada.length === 0 ? (
            <tr>
              <td
                colSpan={columnas.length + 2}
                style={{ textAlign: "center", padding: "20px", fontWeight: "bold" }}
              >
                Sin cotizaciones registradas
              </td>
            </tr>
          ) : (
            <>
              {lineas.map((ln) => {
                const totales = obtenerTotalesPorLinea(ln.nombre);
                return (
                  <React.Fragment key={ln.codigo}>
                    {/* 🔹 Encabezado de línea */}
                    <tr className="pebcd-tabla-rheader">
                      <td colSpan={2}>
                        <div>
                          {iconosMap[ln.icono]} {`LINEA DE ${ln.nombre}`}
                        </div>
                      </td>
                      <td colSpan={columnas.length}></td>
                    </tr>

                    {/* 🔹 Detalle por fase */}
                    <TrDetalleEmbudoVentas
                      data={data.filter((x) => x.linea === ln.nombre)}
                      sucursales={columnas}
                      fases={fases}
                      obtenerTotalFila={obtenerTotalFila}
                      verpor={verpor}
                    />

                    {/* 🔹 Total por línea */}
                    <tr className="pebcd-tabla-total-linea">
                      <td><b>Total</b></td>

                      {totales.map((t) => (
                        <td key={t.col}>{mostrarValor(t.totalCantidad, t.totalMonto)}</td>
                      ))}

                      {/* 🔹 Total final de la línea (suma de columnas) */}
                      <td style={{ fontWeight: "bold", textAlign: "center" }}>
                        {mostrarValor(
                          totales.reduce((acc, t) => acc + t.totalCantidad, 0),
                          totales.reduce((acc, t) => acc + t.totalMonto, 0)
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}

              {/* 🔹 Consolidado general */}
              {lineas.length > 1 && (
                <>
                  <tr className="pebcd-tabla-rheader">
                    <td colSpan={2}> <div><FormatListBulletedIcon /> CONSOLIDADO</div></td>
                    <td colSpan={columnas.length}></td>
                  </tr>
                  {consolidado.map((row) => {
                    const totalFilaCantidad = columnas.reduce((sum, col) => sum + (row[col].cantidad || 0), 0);
                    const totalFilaMonto = columnas.reduce((sum, col) => sum + (row[col].monto || 0), 0);

                    return (
                      <tr key={row.fase} className="pebcd-tabla-rdetalle">
                        <td>{row.fase}</td>

                        {columnas.map((col) => (
                          <td key={col} style={{ textAlign: "center" }}>
                            {mostrarValor(row[col].cantidad, row[col].monto)}
                          </td>
                        ))}

                        {/* Total por fase */}
                        <td style={{ fontWeight: "bold", textAlign: "center" }}>
                          {mostrarValor(totalFilaCantidad, totalFilaMonto)}
                        </td>
                      </tr>
                    );
                  })}


                  {/* 🔹 Total final */}
                  <tr className="pebcd-tabla-total-linea">
                    <td><b>Total</b></td>
                    {columnas.map((col) => {
                      const totalCantidad = consolidado.reduce((acc, row) => acc + (row[col].cantidad || 0), 0);
                      const totalMonto = consolidado.reduce((acc, row) => acc + (row[col].monto || 0), 0);

                      return (
                        <td key={col} style={{ textAlign: "center" }}>
                          {mostrarValor(totalCantidad, totalMonto)}
                        </td>
                      );
                    })}
                    <td style={{ fontWeight: "bold", textAlign: "center" }}>
                      {mostrarValor(
                        columnas.reduce(
                          (acc, col) =>
                            acc + consolidado.reduce((s, row) => s + (row[col].cantidad || 0), 0),
                          0
                        ),
                        columnas.reduce(
                          (acc, col) =>
                            acc + consolidado.reduce((s, row) => s + (row[col].monto || 0), 0),
                          0
                        )
                      )}
                    </td>
                  </tr>
                </>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};
